import { useState, useEffect, useCallback } from 'react';
import { API_URL } from '../Config';

export function useProject(projectId) {
  const [project, setProject] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [timelineItems, setTimelineItems] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const fetchProjectAndTimeline = useCallback(async () => {
    try {
      const projectResponse = await fetch(`${API_URL}/projects/${projectId}`);
      if (!projectResponse.ok) {
        throw new Error(`HTTP error! status: ${projectResponse.status}`);
      }
      const projectData = await projectResponse.json();
      setProject(projectData);
      setVideoUrl(projectData.videoUrl ? `${API_URL}${projectData.videoUrl}` : null);
      setTimelineItems(projectData.timeline_items || []);

      // Extract unique language codes from translations
      const languages = new Set();
      languages.add('original'); // Always include original
      projectData.timeline_items.forEach(item => {
        if (item.translations) {
          item.translations.forEach(translation => {
            languages.add(translation.language_code);
          });
        }
      });
      setAvailableLanguages(Array.from(languages));

    } catch (error) {
      console.error("Error fetching project or timeline:", error);
    }
  }, [projectId]);

  useEffect(() => {
    fetchProjectAndTimeline();
  }, [fetchProjectAndTimeline]);

  const updateProject = useCallback(async (newVideoUrl = null) => {
    if (!project) return;
    const projectToSave = { ...project };
    if (newVideoUrl !== null) {
      // Ensure only the relative path is saved to the database
      projectToSave.videoUrl = newVideoUrl.replace(`${API_URL}`, '');
    }
    delete projectToSave.timeline_items;

    try {
      const response = await fetch(`${API_URL}/projects/${projectId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(projectToSave),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const updatedProject = await response.json();
      setProject(updatedProject);
    } catch (error) {
      console.error("Error saving project metadata:", error);
    }
  }, [project, projectId]);

  return { project, videoUrl, setVideoUrl, timelineItems, setTimelineItems, fetchProjectAndTimeline, updateProject, availableLanguages };
}